export { default as getTokenValue } from '../get-token-value';
